/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Footer_Built_WithInputs */

const en_common_footer_built_with = /** @type {(inputs: Common_Footer_Built_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built with ❤️ ShipAny`)
};

const zh_common_footer_built_with = /** @type {(inputs: Common_Footer_Built_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由 ShipAny ❤️ 强力驱动`)
};

/**
* | output |
* | --- |
* | "Built with ❤️ ShipAny" |
*
* @param {Common_Footer_Built_WithInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_footer_built_with = /** @type {((inputs?: Common_Footer_Built_WithInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Footer_Built_WithInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_footer_built_with(inputs)
	return zh_common_footer_built_with(inputs)
});
export { common_footer_built_with as "common.footer.built_with" }